module.exports = __webpack_public_path__ + "static/media/industrial9.9975d155.webp";